import React from 'react';
import { LoginContainer } from '@/components/Auth/Login/LoginContainer';

export const Login = () => {
    return <LoginContainer />;
};
